import React from "react";
import { View, StyleSheet } from "react-native";
import CustomText from "@components/CustomText";
import DropdownList from "./components/dropdownList";

export default function SelectInputView(props) {
  const { data } = props;
  return (
    <View style={styles.view}>
      <CustomText variant="heading_24" style={styles.heading}>
        {data.heading}
      </CustomText>
      <DropdownList select={true} {...props} />
    </View>
  );
}

const styles = StyleSheet.create({
  view: {
    flex: 1,
    backgroundColor: "white",
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
  heading: {
    fontSize: 22,
    fontFamily: "NotoSansDevanagari-Bold",
    lineHeight: 34,
    color: "rgba(0, 0, 0, 0.86)",
  },
});
